export default __webpack_public_path__ + "static/media/news-en.164c881a.png";